export class ExternalSettings {
  smartfleetServiceURL: string = "/api/smartfleet";
}
